export enum ORDER_BY {
  'DESC' = 'desc',
  'ASC' = 'asc',
}
